/** Целые суммы без дробной части ("392 ₽"), дробные — с двумя знаками ("392.50 ₽") */
export function formatPrice(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
}
